module.exports = __webpack_public_path__ + "static/media/economics_banner.f2feee08.jpg";